module.exports = __webpack_public_path__ + "img/Zhomebie04.d2c371c5.png";